import React from 'react';
import { makeStyles } from '@material-ui/core';
import Analytics from '../../atoms/Analytics';
import { useAuthentication, Role } from '../../contexts/Authentication';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const Home = () => {
  const classes = useStyles();
  const auth = useAuthentication();
  const history = useHistory();

  if (auth.role.some(e => e === Role.Administrateur)) {
    return (
      <div className={classes.container}>
          <Analytics/>
      </div>
    );
  } else {
    history.push("/articles")
    return <></>
  }
}

export default Home;